import ArchiveGallery from "./ArchiveGallery";

function MdfMural() {
  return (
    <ArchiveGallery
      category="mdf"
      showCollectionFilter={false}
      emptyTitle="No MDF murals found in this section."
    />
  );
}

export default MdfMural;
